module.exports = __webpack_public_path__ + "static/media/kelly.1598693a.jpg";